export default __webpack_public_path__ + "f86b4d17a270d72e0954e3deaa99e9a3.svg";